/* MyEbike recently-viewed — localStorage based, max 8, excludes current product. */
(function () {
  'use strict';
  var KEY = 'mb_recent_v1';
  var MAX = 8;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function track(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX) list = list.slice(0, MAX);
    write(list);
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function imageWithWidth(url, width) {
    if (!url) return '';
    // Shopify CDN URLs from /products/handle.js come without a query string,
    // so we use ? — not & — to add the width transform. Path may already be
    // protocol-relative (//cdn.shopify.com/...).
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + width;
  }

  var PLACEHOLDER_SVG =
    '<div class="mb-recent__ph" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">' +
        '<circle cx="6" cy="15" r="4"/><circle cx="18" cy="15" r="4"/>' +
        '<path d="M6 15l6-9h5l1 2"/><path d="M12 6l6 9"/>' +
      '</svg>' +
    '</div>';

  function render(container) {
    if (!container) return;
    var currentHandle = container.dataset.currentHandle || '';
    var items = read().filter(function (h) { return h !== currentHandle; });
    if (items.length === 0) {
      container.closest('[data-mb-recent-root]')?.setAttribute('hidden', '');
      return;
    }

    var endpoint = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Fetch product data via `/products/{handle}.js` for each
    Promise.all(items.slice(0, 4).map(function (h) {
      return fetch(endpoint + 'products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) {
        var priceText = formatMoney(p.price);
        var compareText = (typeof p.compare_at_price === 'number' && p.compare_at_price > p.price)
          ? formatMoney(p.compare_at_price)
          : '';
        var imgSrc = imageWithWidth(p.featured_image, 400);
        var titleEsc = escapeHtml(p.title);
        return '' +
          '<a class="mb-recent__card" href="/products/' + encodeURIComponent(p.handle) + '">' +
            (imgSrc
              ? '<img class="mb-recent__img" src="' + imgSrc + '" alt="' + titleEsc + '" loading="lazy" width="200" height="150">'
              : PLACEHOLDER_SVG) +
            '<div class="mb-recent__meta">' +
              '<span class="mb-recent__title">' + titleEsc + '</span>' +
              '<span class="mb-recent__price-row">' +
                '<span class="mb-recent__price">' + priceText + '</span>' +
                (compareText ? '<s class="mb-recent__compare">' + compareText + '</s>' : '') +
              '</span>' +
            '</div>' +
          '</a>';
      }).join('');
      container.innerHTML = html;
    });
  }

  function init() {
    // track if on a product page
    var productRoot = document.querySelector('[data-mb-pdp-product-handle]');
    if (productRoot) {
      var handle = productRoot.dataset.mbPdpProductHandle;
      track(handle);
    }
    var recentEl = document.querySelector('[data-mb-recent-list]');
    if (recentEl) render(recentEl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
